<template>
  <div class="block">
    <p class="expired__status">
      <i class="fa fa-clock-o"></i>
      {{ $t("page.time_actv.mainheader") }}
    </p>

    <div class="block-text">
      <p>{{ $t("page.time_actv.text1") }}</p>
      <p>{{ $t("page.time_actv.text2") }}</p>
    </div>
    <div class="success-button">
      <button-confirm class="btn" @click="refreshQr">{{
        $t("page.time_actv.button")
      }}</button-confirm>
      <button-confirm class="btnreverse" @click="goBack">
        {{ $t("page.time_actv.button1") }}
      </button-confirm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import ButtonConfirm from "@/components/Recurring/ButtonConfirm";

const store = useStore();

const props = defineProps({
  numberId: {
    type: [Number, String],
    default: 0,
  },
});

const emits = defineEmits(["nextStage"]);

onMounted(() => {
  store.commit("acitvation/SET_NEXT_STAGE_ACTIVATION", "");
});

const refreshQr = () => {
  emits("nextStage", props.numberId ? "telegramActivation" : "viberActivation");
};

const goBack = () => {
  emits("nextStage", "integration");
};
</script>

<style lang="scss" scoped>
.block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  padding: 25px 30px;
  width: 100%;
  border-radius: 11px;
  background: var(--block-color);

  p {
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 25px;
    margin: 0 0 12px;
    color: var(--text-third-color);

    b {
      font-weight: 700;
      color: var(--text-color);
    }
  }

  .expired__status {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 0;

    font-family: "Gilroy", sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
    color: var(--warning-color);

    i {
      font-size: 28px;
    }
  }

  .block-text {
    margin: 16px 0 20px;
  }

  .success-button {
    display: flex;
    flex-wrap: wrap;
    gap: 9px 0;

    .btn {
      margin: 0 10px 0 0;
    }

    .btnreverse {
      background: none;
      color: var(--general-color);
      transition: 0.25s;
      border: 1px solid;
      border-color: var(--general-color);

      &:hover {
        background: var(--general-color);
        color: white;
        border: none;
      }
    }
  }
}

@media screen and (max-width: 573px) {
  .block .success-button {
    width: 100%;
    margin: 0;

    :deep(button) {
    }

    .btn,
    .btnreverse {
      width: 100%;
      margin: 0;
    }
  }

  .block-text {
    margin: 12px 0 16px;
  }

  .block .expired__status {
    font-size: 18px;

    i {
      font-size: 22px;
    }
  }
}
</style>
